/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CustomSkill56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <circle cx={48} cy={8} r={8} fill={vars.bdlBoxBlue10} />
            <circle cx={4} cy={52} r={4} fill={vars.bdlBoxBlue10} />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M39 7H17c-5.43 0-9.848 4.327-9.997 9.72L7 17v22c0 5.43 4.326 9.848 9.72 9.996L17 49h22c5.429 0 9.848-4.327 9.996-9.72L49 39V17c0-5.43-4.327-9.848-9.72-9.996L39 7z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M39 5c6.627 0 12 5.373 12 12v22c0 6.627-5.373 12-12 12H17c-6.628 0-12-5.373-12-12V17c0-6.627 5.372-12 12-12h22zm0 2H17c-5.43 0-9.848 4.327-9.997 9.72L7 17v22c0 5.43 4.326 9.848 9.72 9.996L17 49h22c5.429 0 9.848-4.327 9.996-9.72L49 39V17c0-5.43-4.327-9.848-9.72-9.996L39 7z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M30.447 12.106A1 1 0 0131 13v12h3a1 1 0 01.894 1.447l-8 17A1 1 0 0125 43V31h-3a1 1 0 01-.894-1.447l8-17a1 1 0 011.341-.447z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M28.999 17.044l-5.477 11.955H26c.667 0 1 .334 1 1.001l-.001 8.957 5.479-11.958H30c-.667 0-1-.332-1-.999l-.001-8.956z"
            />
        </g>
    </AccessibleSVG>
);

export default CustomSkill56;
